export const BANK_CODE = [
  {id: '0100'},
  {id: '0300'},
  {id: '0600'},
  {id: '0710'},
  {id: '0800'},
  {id: '2010'},
  {id: '2060'},
  {id: '2070'},
  {id: '2100'},
  {id: '2200'},
  {id: '2220'},
  {id: '2250'},
  {id: '2260'},
  {id: '2600'},
  {id: '2700'},
  {id: '3030'},
  {id: '3060'},
  {id: '3500'},
  {id: '4300'},
  {id: '5500'},
  {id: '5800'},
  {id: '6000'},
  {id: '6200'},
  {id: '6210'},
  {id: '6300'},
  {id: '6363'},
  {id: '6700'},
  {id: '6800'},
  {id: '7910'},
  {id: '7950'},
  {id: '7960'},
  {id: '7970'},
  {id: '7990'},
  {id: '8030'},
  {id: '8040'},
  {id: '8060'},
  {id: '8090'},
  {id: '8150'},
  {id: '8190'},
  {id: '8198'},
  {id: '8220'},
  {id: '8250'},
  {id: '8255'},
  {id: '8265'},
  {id: '8500'},
  {id: '8610'}
]